import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { IParamsDocumentSplitObject } from '../interfaces/params-document-split-object.interface';
import { COURSE_MATERIAL_KEYS, FILE_TO_WRITE_OBJECT } from '../values/courses.values';
import EdPreviewFilePages from '@/courses/components/ed-preview-file-pages/ed-preview-file-pages.vue'
import EdDocumentToSplitObject from '../components/ed-document-to-split-object/ed-document-to-split-object.vue';
import EdSelectComponentCourse from '@/course-templates/components/ed-select-component-course/ed-select-component-course.component.vue';
import {IParamsCreateComponent} from '@/courses/interfaces/params-create-component.interface';
import EdPdfRotatePages from '@/courses/components/ed-pdf-rotate-pages/ed-pdf-rotate-pages.vue';
import { CourseToolsMixin } from './course-tools.mixin';
import { SECTION_TYPES } from '@/content/values/sections';

@Component({
  components: {
    EdDocumentToSplitObject,
    EdPreviewFilePages,
    EdSelectComponentCourse,
    EdPdfRotatePages,
  }
})
export class CreateSplitObjectMixin extends Mixins(CourseToolsMixin)  {

  @Prop() readonly courseId: number;

  public problemFile  = { type: FILE_TO_WRITE_OBJECT.FILE, data: null, valid: false };
  public problemParams: IParamsDocumentSplitObject = { 
    edition: false, name: 'problem'
  };

  public solutionFile = { type: FILE_TO_WRITE_OBJECT.FILE, data: null, valid: false };
  public solutionParams: IParamsDocumentSplitObject = { 
    edition: false, name: 'solution'
  };

  public selectPagesVisible: boolean = false;
  public pageSelectedSection: string = 'problem';
  public selectPagesParams: any = {};
  public showEduacComponentModal: boolean = false;
  public paramsComponent: any = {};
  private rotationModeProblemEnable: boolean = false;
  private rotationModeSolutionEnable: boolean = false;
  private rotationModeProblemFileEnable: boolean = false;
  private rotationModeSolutionFileEnable: boolean = false;
  private lastUrl : string = '';
  public hasBeenHomeworkResolvedByAnyStudent : boolean = false;
  public rotatePagesParams: any = {};

  get hasProblemFile() {
    return this.problemFile.data ? true : false;
  }

  get hasSolutionFile() {
    return this.solutionFile.data ? true : false;
  }

  get isSolutionValid() {
    if(this.hasSolutionFile) {
      return this.solutionFile.valid; 
    }
    return true;
  }

  get pdfUrl() {
    if(this.pageSelectedSection == 'problem' && this.hasProblemFile && this.problemFile.type == FILE_TO_WRITE_OBJECT.COURSE_MATERIAL) {
      return this.problemFile.data.material.data.pdfUrl;
    }
    if(this.pageSelectedSection == 'solution' && this.hasSolutionFile && this.solutionFile.type == FILE_TO_WRITE_OBJECT.COURSE_MATERIAL) {
      return this.solutionFile.data.material.data.pdfUrl;
    }
    return null;
  }

  get rotationModelEnable() {
    return this.rotationModeSolutionEnable || this.rotationModeProblemEnable || this.rotationModeSolutionFileEnable || this.rotationModeProblemFileEnable;
  }

  get sectionUpdated() {
    return this.$store.state.CourseStore.sectionToEdit;
  }

  get componentSelected() : IParamsCreateComponent {
    return this.$store.state.CourseStore.eduacComponentSelected;
  }
  
  set componentSelected(newValue : IParamsCreateComponent) {
    this.$Courses.Store.setEduacComponentSelected(newValue);
  }

  setProblemForEdition(problem, courseId) {
    Object.assign(this.problemFile, problem);
    this.problemFile.valid = true;
    this.problemParams.edition = true;
    this.problemParams.type = this.problemFile.type;
    this.problemParams.data = this.problemFile.data;
    this.problemFile.data.courseId = (this.problemFile.data.courseId) ? this.problemFile.data.courseId : courseId;
    this.problemParams.data.courseId = (this.problemParams.data.courseId) ? this.problemParams.data.courseId : courseId;
  }

  setSolutionForEdition(solution, courseId) {
    Object.assign(this.solutionFile, solution);
    if(this.solutionFile) {
      this.solutionFile.valid = true;
      this.solutionParams.edition = true;
      this.solutionParams.type = this.solutionFile.type;
      this.solutionParams.data = this.solutionFile.data;
      if(this.solutionFile.data) {
        this.solutionFile.data.courseId = (this.solutionFile.data.courseId) ? this.solutionFile.data.courseId : courseId;
      }
      if(this.solutionParams.data) {
        this.solutionParams.data.courseId = (this.solutionParams.data.courseId) ? this.solutionParams.data.courseId : courseId;
      }
      
    }
  }

  goToSelectPages(section: any) {
    this.pageSelectedSection = section.name;
    this.selectPagesParams = section;
    this.selectPagesVisible = true;
  }

  onPagesSelected(data: any) {
    let problem: any = this.$refs.ProblemDocument;
    let solution: any = this.$refs.SolutionDocument;
    if(this.pageSelectedSection == 'problem') {
      problem.setPagesSelected(data);
    } else {
      solution.setPagesSelected(data);
    }
    this.selectPagesVisible = false;
  }

  getIsTheSameCourseMaterial(prevFile, currentFile) {
    if(prevFile.data && currentFile.data) {
      return prevFile.type !== currentFile.type;
    } else if(!currentFile.data) {
      return true;
    }
    return false;
  }

  goBack() {
    this.selectPagesVisible = false;
  }

  changeComponent(data) {
    this.componentSelected = data;
  }

  showParentForm(data) {
    this.showEduacComponentModal = false;
  }

  rotateModalProblem() {
    this.rotationModeProblemEnable = true;
    this.rotatePagesParams = {type: SECTION_TYPES.SPLIT_QUESTION_PDF.code, courseId: this.courseId};
  }

  rotateModalSolution() {
    this.rotationModeSolutionEnable = true;
    this.rotatePagesParams = {type: SECTION_TYPES.SPLIT_SOLUTION_PDF.code, courseId: this.courseId};
  }

  rotateModalProblemFile() {
    this.rotationModeProblemFileEnable = true;
    this.rotatePagesParams = {type: SECTION_TYPES.SPLIT_QUESTION_PDF.code, courseId: this.courseId};
  }

  rotateModalSolutionFile() {
    this.rotationModeSolutionFileEnable = true;
    this.rotatePagesParams = {type: SECTION_TYPES.SPLIT_SOLUTION_PDF.code, courseId: this.courseId};
  }

  onRotatePages(rotatePageList:{page:number,rotateDegrees:number}[]) {
    if( (rotatePageList || []).length <= 0 ) {
      this.disableRotateModal();
    } else if(this.hasBeenHomeworkResolvedByAnyStudent && (this.rotationModeProblemEnable || this.rotationModeProblemFileEnable)) {
      this.$EdModal.createConfirmationModal(
        {
          body: this.$i18n.t('courses.objects.confirmRotateEdit'),
          action: async () => {
            this.saveRotatePages(rotatePageList);
          },
          secondAction: () => {
            this.disableRotateModal();
          }
        }
      );
    } else {
      this.saveRotatePages(rotatePageList);
    }
  }

  saveRotatePages(rotatePageList:{page:number,rotateDegrees:number}[]) {
    if(this.rotationModeProblemEnable) {
      this.onRotatePagesProblem(rotatePageList);
    } else if(this.rotationModeProblemFileEnable) {
      this.onRotatePagesProblemFile(rotatePageList);
    } else if(this.rotationModeSolutionEnable) {
      this.onRotatePagesSolution(rotatePageList);
    } else {
      this.onRotatePagesSolutionFile(rotatePageList);
    }
  }

  async onRotatePagesProblemFile(rotatePageList:{page:number,rotateDegrees:number}[]) {
    const sectionId = this.problemFile.data.id;
    const courseId = this.problemFile.data.courseId;
    const newHash = await this.$Courses.Store.rotateContentAssetA({courseId, sectionId, rotatePageList});
    if(newHash) {
      this.getProblemFilePdfUrl();
    } else {
      this.rotationModeProblemFileEnable = false;
    }
  }

  async onRotatePagesProblem(rotatePageList:{page:number,rotateDegrees:number}[]) {
    const sectionId = this.problemParams.data.id;
    const courseId = this.problemParams.data.courseId;
    const newHash = await this.$Courses.Store.rotateContentAssetA({courseId, sectionId, rotatePageList});
      if(newHash) {
        this.getProblemPdfUrl();
      } else {
        this.rotationModeProblemEnable = false;
      }
  }

  async onRotatePagesSolutionFile(rotatePageList:{page:number,rotateDegrees:number}[]) {
    const sectionId = this.solutionFile.data.id;
    const courseId = this.solutionFile.data.courseId;
    const newHash = await this.$Courses.Store.rotateContentAssetA({courseId, sectionId, rotatePageList});
    if(newHash) {
      this.getSolutionPdfFileUrl();
    } else {
      this.rotationModeSolutionFileEnable = false;
    }
  }

  async onRotatePagesSolution(rotatePageList:{page:number,rotateDegrees:number}[]) {
    const sectionId = this.solutionParams.data.id;
    const courseId = this.solutionParams.data.courseId;
    const newHash = await this.$Courses.Store.rotateContentAssetA({courseId, sectionId, rotatePageList});
    if(newHash) {
      this.getSolutionPdfUrl();
    } else {
      this.rotationModeSolutionEnable = false;
    }
  }

  async getProblemPdfUrl() {
    let fileData = { sectionId: this.problemParams.data.parentId , materialId: null ,
      courseId: this.problemParams.data.courseId , classId: this.problemParams.data.classId};

    this.getPdfUrl(fileData);
  }

  async getProblemFilePdfUrl() {
    let fileData = { sectionId: this.problemFile.data.parentId , materialId: null ,
      courseId: this.problemFile.data.courseId , classId: this.problemFile.data.classId};

    this.getPdfUrl(fileData);
  }

  async getSolutionPdfUrl() {
    let fileData = { sectionId: this.solutionParams.data.parentId , materialId: null ,
      courseId: this.solutionParams.data.courseId , classId: this.solutionParams.data.classId};

    this.getPdfUrl(fileData);
  }

  async getSolutionPdfFileUrl() {
    let fileData = { sectionId: this.solutionFile.data.parentId , materialId: null ,
      courseId: this.solutionFile.data.courseId , classId: this.solutionFile.data.classId};

    this.getPdfUrl(fileData);
  }

  async getPdfUrl(fileData) {
    this.deleteFromStorage(fileData.sectionId , null);
    let isProcessing = this.checkStorage(fileData.sectionId , null);
    if(isProcessing) {
      let intervalId : any = setInterval((data) => {
        this.waitForReadyFileInfo(intervalId , data).then(
          (status) => {
            if(status != 206) {
              const url = this.getPdfUrlForVisualRotation();
              if(url && url !== this.lastUrl) {
                this.lastUrl = url;
                this.disableRotateModal();
              } else {
                this.getPdfUrl(fileData);
              }
            } else {
              this.getPdfUrl(fileData);
            }
          }
        );
      }, 15000 , fileData);
    }
  }

  disableRotateModal() {
    this.rotationModeProblemEnable = false;
    this.rotationModeProblemFileEnable = false;
    this.rotationModeSolutionEnable = false;
    this.rotationModeSolutionFileEnable = false;
  }

  getPdfUrlForVisualRotation() {
    if(this.rotationModeProblemEnable) {
      return this.getPdfUrlForVisualRotationProblem();
    } else if(this.rotationModeProblemFileEnable) {
      return this.getPdfUrlForVisualRotationProblemFile();
    } else if(this.rotationModeSolutionEnable) {
      return this.getPdfUrlForVisualRotationSolution();
    } else {
      return this.getPdfUrlForVisualRotationSolutionFile();
    }
  }

  getPdfUrlForVisualRotationProblem() {
    let pdfurl = null;

    let sectionToEdit = (this.sectionUpdated && this.sectionUpdated?.id == this.problemParams?.data?.parentId) ? 
      this.sectionUpdated?.sections.find(object => object.id === this.problemParams?.data?.id) : 
      this.problemParams.data;
    
    pdfurl = this.getUrlFromSectionData(sectionToEdit, pdfurl);
    return pdfurl;
  }

  getPdfUrlForVisualRotationProblemFile() {
    let pdfurl = null;

    let sectionToEdit = (this.sectionUpdated && this.sectionUpdated?.id == this.problemFile?.data?.parentId) ? 
      this.sectionUpdated?.sections.find(object => object.id === this.problemFile?.data?.id) : 
      this.problemFile.data;
  
    pdfurl = this.getUrlFromSectionData(sectionToEdit, pdfurl);
    return pdfurl;
  }

  getPdfUrlForVisualRotationSolution() { 
    let pdfurl = null;

    if(this.solutionParams) {
      let sectionToEdit = (this.sectionUpdated && this.sectionUpdated?.id == this.solutionParams?.data?.parentId) ? 
        this.sectionUpdated?.sections.find(object => object.id === this.solutionParams?.data?.id) : 
        this.solutionParams.data;
    
      pdfurl = this.getUrlFromSectionData(sectionToEdit, pdfurl);
    }
    return pdfurl;
  }

  getPdfUrlForVisualRotationSolutionFile() {
    let pdfurl = null;

    if(this.solutionFile) {
      let sectionToEdit = (this.sectionUpdated && this.sectionUpdated?.id == this.solutionFile?.data?.parentId) ? 
        this.sectionUpdated?.sections.find(object => object.id === this.solutionFile?.data?.id) : 
        this.solutionFile.data;
    
      pdfurl = this.getUrlFromSectionData(sectionToEdit, pdfurl);
    }
    return pdfurl;
  }

  getUrlFromSectionData(sectionToEdit: any, pdfurl: any) {
    if (sectionToEdit) {
      if (sectionToEdit.assetsInfo && sectionToEdit.assetsInfo[0].url) {
        if (sectionToEdit.assetsInfo[0].pdfUrl) {
          pdfurl = sectionToEdit.assetsInfo[0].pdfUrl;
        }
      } else if (sectionToEdit.sectionMaterial?.displayType === COURSE_MATERIAL_KEYS.SPLICE &&
        sectionToEdit.sectionMaterial.splicedUrl) {
        pdfurl = sectionToEdit.sectionMaterial.splicedUrl;
      } else if (sectionToEdit.sectionMaterial?.displayType === COURSE_MATERIAL_KEYS.CONTINUE &&
        sectionToEdit.sectionMaterial?.materialAssetInfo?.pdfUrl) {
        pdfurl = sectionToEdit.sectionMaterial?.materialAssetInfo?.pdfUrl;
      }
    }
    return pdfurl;
  }

  created() {
    this.solutionParams.disclamer = String(this.$i18n.t('courses.writeObject.solutionDisclamer'));
    this.problemParams.disclamer = String(this.$i18n.t('courses.writeObject.problemDisclamerSection'));
    this.$Courses.Store.resetSectionToEditM();
  }

}


